import qs from 'qs';

export const addQuery = (
  params: Record<string, string | number | undefined>
): { search: string } => {
  const currentParams = qs.parse(window.location.search, {
    ignoreQueryPrefix: true
  });

  return {
    search: qs.stringify(
      { ...currentParams, ...params },
      { addQueryPrefix: true }
    )
  };
};

export const updateQuery = (
  params: Record<string, string | number | undefined>
): { search: string; pathname?: string } => {
  return {
    search: qs.stringify({ ...params }, { addQueryPrefix: true })
  };
};
